/**
 *  interface for Login Type
 */
export enum BrandTypes {
  GET_BRAND = '@@brand/GET_BRAND',
  GET_BRAND_SUCCESS = '@@brand/GET_BRAND_SUCCESS',
  GET_BRAND_FAILED = '@@brand/GET_BRAND_FAILED',

  GET_BRAND_BY_NETWORK = '@@brand/GET_BRAND_BY_NETWORK',
  GET_BRAND_BY_NETWORK_SUCCESS = '@@brand/GET_BRAND_BY_NETWORK_SUCCESS',
  GET_BRAND_BY_NETWORK_FAILED = '@@brand/GET_BRAND_BY_NETWORK_FAILED',
}
